import React from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import IconButton from '@material-ui/core/IconButton';

import { CrossIcon } from '../Icons/CrossIcon';

import styles from './styles.module.scss';

interface TransitionsModalProps {
  title: string;
  actions?: React.ReactNode;
  alternativeActions?: React.ReactNode;
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  testId?: string;
}

export function TransitionsModal({
  title,
  actions,
  alternativeActions,
  children,
  open,
  onClose,
  testId,
}: TransitionsModalProps) {
  const actionsProvided = !!actions;
  const alternativeActionsProvided = !!alternativeActions;

  return (
    <Modal
      className={styles.modal}
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      aria-labelledby="transition-modal-title"
      data-testid={testId}
    >
      <Fade in={open}>
        <div className={styles.paper}>
          <div className={styles.header}>
            <div className={styles.titleWrapper}>
              <h2
                className={styles.title}
                id="transition-modal-title"
                data-testid="modal-title"
              >
                {title}
              </h2>
              {actionsProvided && !alternativeActionsProvided && (
                <div className={styles.actions}>{actions}</div>
              )}
            </div>
            <IconButton
              className={styles.close}
              aria-label="close"
              onClick={onClose}
            >
              <CrossIcon width={16} height={16} color="#282828" />
            </IconButton>
          </div>
          <div className={styles.altActionsWrapper}>
            {alternativeActionsProvided && alternativeActions}
          </div>
          <div className={styles.content}>{children}</div>
        </div>
      </Fade>
    </Modal>
  );
}
